import { render, staticRenderFns } from "./review-and-sign-popup.vue?vue&type=template&id=746a752e&"
import script from "./review-and-sign-popup.vue?vue&type=script&lang=js&"
export * from "./review-and-sign-popup.vue?vue&type=script&lang=js&"
import style0 from "./review-and-sign-popup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports